import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Popup.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/state";
import PopupForm from '../PopupForm';
const Popup = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const [themeInvert, setThemeInvert] = useState(false);
  const { updatePopupOpen, popupOpen } = state;
  const refWrap = useRef(null);
  const updateThemeInvert = (bool) => setThemeInvert(bool);


  useEffect(() => {
    const wrap = refWrap.current;
    const body = document.body;
    if (popupOpen) {
      wrap.classList.add(styles.active);
      body.style.overflow = 'hidden';
    } else {
      wrap.classList.remove(styles.active);
      body.style.overflow = '';
    }
  }, [popupOpen]);

  useEffect(() => {
    const wrap = refWrap.current;
    if (window.innerWidth < 768) return;
    if (themeInvert) {
      wrap.classList.add(styles.invert);
    } else {
      wrap.classList.remove(styles.invert);
    }
    return () => {
      wrap.classList.remove(styles.invert);
    }
  }, [themeInvert]);

  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.overlay} onClick={() => updatePopupOpen(false)}></div>
        <div className={styles.popup}>
          <div className={styles.close} onClick={() => updatePopupOpen(false)}>
            <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="25.5" cy="25.5" r="24.5" stroke="#BDBFCD" strokeWidth="2" />
              <path d="M35.5 16L25.25 26.25M15 36.5L25.25 26.25M25.25 26.25L15 16L35.5 36.5" stroke="#BDBFCD" strokeWidth="2" />
            </svg>

          </div>
          <div className={styles.body}>
            <div className={styles.inner}>

              <PopupForm updateThemeInvert={updateThemeInvert} />
            </div>
          </div>
        </div>
      </div>
    </>
  );

}

export default Popup;
